import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';

export const DEFAULT_COUNTRY_CODE: CountryCode = 'AR';

export function isValidPhone(phone: string | null | undefined): boolean {
  const trimmedPhone = phone?.trim();
  return !!trimmedPhone && isValidPhoneNumber(trimmedPhone, DEFAULT_COUNTRY_CODE);
}

export default { isValidPhone, DEFAULT_COUNTRY_CODE };
